/** Round to nearest integer cent. */
export function roundCents(value) {
    return Math.round(value);
}
/** Convert dollars to integer cents. */
export function toCents(dollars) {
    return Math.round(dollars * 100);
}
/** Convert integer cents to dollars. */
export function centsToDollars(cents) {
    return cents / 100;
}
const usdFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});
/** Display money as USD. */
export function formatUsd(cents) {
    return usdFormatter.format(centsToDollars(cents));
}
/**
 * Display a per-mile money amount. Per-mile figures from analyze()
 * (keepPerLoadedMile, profitPerLoadedMile, ...) are CENTS per mile and may be
 * fractional: 120000 cents / 200 mi = 600 → "$6.00".
 */
export function formatUsdPerMile(centsPerMile) {
    return usdFormatter.format(Math.round(centsPerMile) / 100);
}
//# sourceMappingURL=money.js.map